




























import { Vue, Component } from "vue-property-decorator";
import CardTitle from "../../components/CardTitle.vue";
import * as data from "../../_store/data.module";
import * as user from "../../_store/user.module";
import { bus } from "../../main";
import { ArticolazioneInfo } from "../../_models/articolazioneInfo";
import { userUtils } from "../../_utils/userUtils";
import * as auth from "../../_store/auth.module";
import { router } from "../../_router";

@Component({
  components: {
    CardTitle
  }
})
export default class Curriculum extends Vue {
  private idAllievo: number;
  private titleParams: object;
  private listaIstituti: any;
  private isComplete: boolean;

  constructor() {
    super();
    this.idAllievo = 1015;
    this.titleParams = {
      title: "Curriculum Vitae",
      cols: "12",
      sm: "5",
      md: "5",
      lg: "4"
    };
    this.listaIstituti = [];
    this.isComplete = false;
  }

  checkValid(idIstituto:number) {
    var enterpriseInfo = user.readEnterpriseInfo(this["$store"]);
    var payload = {
      idAzienda: enterpriseInfo.idAzienda,
      idIstituto: idIstituto
    };
    var idIstitutoString: string = String(idIstituto)
    this.isComplete = userUtils.checkEnterpriseInfo(enterpriseInfo);
    if (this.isComplete !== false) {
      data
        .dispatchRespDoc(this["$store"], payload)
        .then(response => {
          if (
            response.IdDocNominaResponsabile !== undefined &&
            response.IdDocNominaResponsabile !== null
          ) {
            if (response.StatoDocumento === 2) {
              router.push({
                name: "curriculumVitaeAnni",
                params: {
                  idIstituto: idIstitutoString
                }
              });
            } else {
              bus.$emit(
                "noDoc",
                "E' necessario attendere la verifica del documento per la nomina del responsabile trattamento dati"
              );
            }
          } else {
            bus.$emit(
              "noDoc",
              "E' necessario compilare il documento per la nomina del responsabile trattamento dati. Questo si può trovare nella sezione 'Amministrazione'/'Moduli'"
            );
          }
        })
        .catch(error => {
          if (error.response.status === 401) {
            bus.$emit("errorOperation", error.response.statusText);
            this["$router"].push("/login");
          } else {
            bus.$emit("errorOperation", error.response.statusText);
          }
        });
    } else {
      bus.$emit("incompleteInfo");
    }
  }

  created() {
    var token = localStorage.getItem("userToken");
    var parsedToken: any;
    if (token !== null) {
      parsedToken = userUtils.parseToken(token);
    }
    var payload = {
      idUtente: parsedToken.IdUtente,
      tipoSoggetto: parsedToken.IdTipoSoggetto,
      username: parsedToken.Username
    };
    user
      .dispatchSetUserInfo(this["$store"], payload)
      .then(() => {
        if (payload.tipoSoggetto === 2) {
          user
            .dispatchSetInstituteInfo(this["$store"])
            .then(() => {
              var instituteInfo = user.readInstituteInfo(this["$store"]);
              bus.$emit("loadMenu");
              router.push({
                name: "curriculumVitaeAnni",
                params: {
                  idIstituto: String(instituteInfo.id)
                }
              });
            })
            .catch(() => {
              bus.$emit("stopLoading");
              auth.dispatchLogout(this["$store"]);
              user.dispatchClearState(this["$store"]);
              this["$router"].push("/sessionExpired");
            });
        } else if (payload.tipoSoggetto === 3) {
          user
            .dispatchSetEnterpriseInfo(this["$store"])
            .then(() => {
              var enterpriseInfo = user.readEnterpriseInfo(this["$store"]);
              data
                .dispatchCollaborationInstitutes(
                  this["$store"],
                  enterpriseInfo.idAzienda
                )
                .then(result => {
                  this.listaIstituti = result;
                  bus.$emit("loadMenu");
                });
            })
            .catch(() => {
              bus.$emit("stopLoading");
              auth.dispatchLogout(this["$store"]);
              user.dispatchClearState(this["$store"]);
              this["$router"].push("/sessionExpired");
            });
        } else {
          bus.$emit("stopLoading");
          auth.dispatchLogout(this["$store"]);
          user.dispatchClearState(this["$store"]);
          this["$router"].push("/login");
          bus.$emit("errorOperation", "Errore nel caricamento dati");
        }
      })
      .catch(() => {
        bus.$emit("stopLoading");
        auth.dispatchLogout(this["$store"]);
        user.dispatchClearState(this["$store"]);
        this["$router"].push("/sessionExpired");
      });
  }
}
